import { render, staticRenderFns } from "./PrizesSection.vue?vue&type=template&id=28d2ca6c&scoped=true&"
import script from "./PrizesSection.vue?vue&type=script&lang=js&"
export * from "./PrizesSection.vue?vue&type=script&lang=js&"
import style0 from "./PrizesSection.vue?vue&type=style&index=0&id=28d2ca6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2ca6c",
  null
  
)

export default component.exports